import React, { useEffect, useState } from 'react';
import { Row } from 'react-bootstrap';



function ReviewCard(props) {

  function showMoreLess(id) {
    var dots = document.getElementById("dots" + id);
    var moreText = document.getElementById("moreReview" + id);
    var btnText = document.getElementById("myBtn" + id);

    if (dots.style.display === "none") {
      dots.style.display = "inline";
      btnText.innerHTML = "Read more";
      moreText.style.display = "none";
    } else {
      dots.style.display = "none";
      btnText.innerHTML = "Read less";
      moreText.style.display = "inline";
    }
  }

  switch (props.rating) {
    case 1:

      return (
        <>
          <Row className=" card card1 m-1 d-flex py-2" key={props.id}>
            <div className="col-4">
              {props.images.map((item, index) => {
                if (item.baseImage === true) {
                  if (item.image.startsWith("products")) {
                    return (
                      <>
                        <img src={"https://s3.toolsvilla.com/" + item.image} className="col-hw img-C-Products" key={index} alt="img"></img>
                      </>
                    )
                  }
                  else {
                    var img = item.image.substr("41")
                    return (<>
                      <img src={"https://s3.toolsvilla.com/" + img} className="col-hw img-C-Products" key={img} alt="img"></img>
                    </>
                    )
                  }
                }
              })
              }
              {/* <img src="/spice.png" className="col-hw img-C-Products"></img> */}
            </div>
            <div className="col-8 ">

              <span className="fs-13 theme-col f-700" >{props.productName}</span>
              <p className="theme-col fs-11 f-500 mb-0"> Quantity: 2</p>

              <p className="theme-col fs-12 f-700 mb-0">Order ID: 11065681</p>
              <p className="theme-col fs-12 f-700 mb-0">Customer's Rating:

                <span className="text-yellow">
                  <i className="fa fa-star "></i>
                  <i className="fa fa-star gry"></i>
                  <i className="fa fa-star gry"></i>
                  <i className="fa fa-star gry"></i>
                  <i className="fa fa-star gry"></i>
                </span></p>
              {props.review.length > 20 ? <><p className="theme-col fs-12 f-700">Customer's Review:
                <p>{props.review.slice(0, 20)}
                  <span id={"dots" + props.id}>...</span>
                  <span id={"moreReview" + props.id} className="moreReviewsSection">{props.review.slice(20, props.review.length)}
                  </span>
                  <span className="reviewRmRl-label" onClick={() => showMoreLess(props.id)} id={"myBtn" + props.id}>Read more</span>
                </p>
              </p>
              </> : <><p className="theme-col fs-12 f-700">Customer's Review:
                <span>{props.review}
                </span>
              </p>
              </>
              }
            </div>
          </Row>
        </>
      )
      break;
    case 2:

      return (
        <>
          <Row className=" card card1 m-1 d-flex py-2">
            <div className="col-4">
            {props.images.map((item, index) => {
                if (item.baseImage === true) {
                  if (item.image.startsWith("products")) {
                    return (
                      <>
                        <img src={"https://s3.toolsvilla.com/" + item.image} className="col-hw img-C-Products" key={index} alt="img"></img>
                      </>
                    )
                  }
                  else {
                    var img = item.image.substr("41")
                    return (<>
                      <img src={"https://s3.toolsvilla.com/" + img} className="col-hw img-C-Products" key={img} alt="img"></img>
                    </>
                    )
                  }
                }
              })
              }
            </div>
            <div className="col-8 ">

              <span className="fs-13 theme-col f-700" >{props.productName}</span>
              <p className="theme-col fs-11 f-500 mb-0"> Quantity: 2</p>

              <p className="theme-col fs-12 f-700 mb-0">Order ID: 11065681</p>
              <p className="theme-col fs-12 f-700 mb-0">Customer's Rating:

                <span className="text-yellow">
                  <i className="fa fa-star "></i>
                  <i className="fa fa-star "></i>
                  <i className="fa fa-star gry"></i>
                  <i className="fa fa-star gry"></i>
                  <i className="fa fa-star gry"></i>
                </span></p>
              {props.review.length > 20 ? <><p className="theme-col fs-12 f-700">Customer's Review:
                <p>{props.review.slice(0, 20)}
                  <span id={"dots" + props.id}>...</span>
                  <span id={"moreReview" + props.id} className="moreReviewsSection">{props.review.slice(20, props.review.length)}
                  </span>
                  <span className="reviewRmRl-label" onClick={() => showMoreLess(props.id)} id={"myBtn" + props.id}>Read more</span>
                </p>
              </p>
              </> : <><p className="theme-col fs-12 f-700">Customer's Review:
                <span>{props.review}
                </span>
              </p>
              </>
              }

            </div>
          </Row>
        </>
      )
      break;
    case 3:

      return (
        <>
          <Row className=" card card1 m-1 d-flex py-2">
            <div className="col-4">
            {props.images.map((item, index) => {
                if (item.baseImage === true) {
                  if (item.image.startsWith("products")) {
                    return (
                      <>
                        <img src={"https://s3.toolsvilla.com/" + item.image} className="col-hw img-C-Products" key={index} alt="img"></img>
                      </>
                    )
                  }
                  else {
                    var img = item.image.substr("41")
                    return (<>
                      <img src={"https://s3.toolsvilla.com/" + img} className="col-hw img-C-Products" key={img} alt="img"></img>
                    </>
                    )
                  }
                }
              })
              }
            </div>
            <div className="col-8 ">

              <span className="fs-13 theme-col f-700" >{props.productName}</span>
              <p className="theme-col fs-11 f-500 mb-0"> Quantity: 2</p>

              <p className="theme-col fs-12 f-700 mb-0">Order ID: 11065681</p>
              <p className="theme-col fs-12 f-700 mb-0">Customer's Rating:

                <span className="text-yellow">
                  <i className="fa fa-star "></i>
                  <i className="fa fa-star "></i>
                  <i className="fa fa-star "></i>
                  <i className="fa fa-star gry"></i>
                  <i className="fa fa-star gry"></i>
                </span></p>
              {props.review.length > 20 ? <><p className="theme-col fs-12 f-700">Customer's Review:
                <p>{props.review.slice(0, 20)}
                  <span id={"dots" + props.id}>...</span>
                  <span id={"moreReview" + props.id} className="moreReviewsSection">{props.review.slice(20, props.review.length)}
                  </span>
                  <span className="reviewRmRl-label" onClick={() => showMoreLess(props.id)} id={"myBtn" + props.id}>Read more</span>
                </p>
              </p>
              </> : <><p className="theme-col fs-12 f-700">Customer's Review:
                <span>{props.review}
                </span>
              </p>
              </>
              }

            </div>
          </Row>
        </>
      )
      break;
    case 4:

      return (
        <>
          <Row className=" card card1 m-1 d-flex py-2">
            <div className="col-4">
            {props.images.map((item, index) => {
                if (item.baseImage === true) {
                  if (item.image.startsWith("products")) {
                    return (
                      <>
                        <img src={"https://s3.toolsvilla.com/" + item.image} className="col-hw img-C-Products" key={index} alt="img"></img>
                      </>
                    )
                  }
                  else {
                    var img = item.image.substr("41")
                    return (<>
                      <img src={"https://s3.toolsvilla.com/" + img} className="col-hw img-C-Products" key={img} alt="img"></img>
                    </>
                    )
                  }
                }
              })
              }
            </div>
            <div className="col-8 ">

              <span className="fs-13 theme-col f-700" >{props.productName}</span>
              <p className="theme-col fs-11 f-500 mb-0"> Quantity: 2</p>

              <p className="theme-col fs-12 f-700 mb-0">Order ID: 11065681</p>
              <p className="theme-col fs-12 f-700 mb-0">Customer's Rating:

                <span className="text-yellow">
                  <i className="fa fa-star "></i>
                  <i className="fa fa-star "></i>
                  <i className="fa fa-star "></i>
                  <i className="fa fa-star "></i>
                  <i className="fa fa-star gry"></i>
                </span></p>
              {props.review.length > 20 ? <><p className="theme-col fs-12 f-700">Customer's Review:
                <p>{props.review.slice(0, 20)}
                  <span id={"dots" + props.id}>...</span>
                  <span id={"moreReview" + props.id} className="moreReviewsSection">{props.review.slice(20, props.review.length)}
                  </span>
                  <span className="reviewRmRl-label" onClick={() => showMoreLess(props.id)} id={"myBtn" + props.id}>Read more</span>
                </p>
              </p>
              </> : <><p className="theme-col fs-12 f-700">Customer's Review:
                <span>{props.review}
                </span>
              </p>
              </>
              }

            </div>
          </Row>
        </>
      )
      break;
    case 5:

      return (
        <>
          <Row className=" card card1 m-1 d-flex py-2">
            <div className="col-4"> {props.images.map((item, index) => {
                if (item.baseImage === true) {
                  if (item.image.startsWith("products")) {
                    return (
                      <>
                        <img src={"https://s3.toolsvilla.com/" + item.image} className="col-hw img-C-Products" key={index} alt="img"></img>
                      </>
                    )
                  }
                  else {
                    var img = item.image.substr("41")
                    return (<>
                      <img src={"https://s3.toolsvilla.com/" + img} className="col-hw img-C-Products" key={img} alt="img"></img>
                    </>
                    )
                  }
                }
              })
              }</div>
            <div className="col-8 ">

              <span className="fs-13 theme-col f-700" >{props.productName}</span>
              <p className="theme-col fs-11 f-500 mb-0"> Quantity: 2</p>

              <p className="theme-col fs-12 f-700 mb-0">Order ID: 11065681</p>
              <p className="theme-col fs-12 f-700 mb-0">Customer's Rating:

                <span className="text-yellow">
                  <i className="fa fa-star "></i>
                  <i className="fa fa-star "></i>
                  <i className="fa fa-star "></i>
                  <i className="fa fa-star "></i>
                  <i className="fa fa-star "></i>
                </span></p>
              {props.review.length > 20 ? <><p className="theme-col fs-12 f-700">Customer's Review:
                <p>{props.review.slice(0, 20)}
                  <span id={"dots" + props.id}>...</span>
                  <span id={"moreReview" + props.id} className="moreReviewsSection">{props.review.slice(20, props.review.length)}

                  </span>
                  <span className="reviewRmRl-label" onClick={() => showMoreLess(props.id)} id={"myBtn" + props.id}>Read more</span>
                </p>
              </p>
              </> : <><p className="theme-col fs-12 f-700">Customer's Review:
                <span>{props.review}
                </span>
              </p>
              </>
              }

            </div>
          </Row>
        </>
      )
      break;
    default:

      return (
        <>
          <Row className=" card card1 m-1 d-flex py-2">
            <div className="col-4"> {props.images.map((item, index) => {
                if (item.baseImage === true) {
                  if (item.image.startsWith("products")) {
                    return (
                      <>
                        <img src={"https://s3.toolsvilla.com/" + item.image} className="col-hw img-C-Products" key={index} alt="img"></img>
                      </>
                    )
                  }
                  else {
                    var img = item.image.substr("41")
                    return (<>
                      <img src={"https://s3.toolsvilla.com/" + img} className="col-hw img-C-Products" key={img} alt="img"></img>
                    </>
                    )
                  }
                }
              })
              }</div>
            <div className="col-8 ">

              <span className="fs-13 theme-col f-700" >{props.productName}</span>
              <p className="theme-col fs-11 f-500 mb-0"> Quantity: 2</p>

              <p className="theme-col fs-12 f-700 mb-0">Order ID: 11065681</p>
              {/* <p className="theme-col fs-12 f-700 mb-0">Customer's Rating:  */}

              {/* <span className="text-yellow">
                <i className="fa fa-star "></i>
                <i className="fa fa-star gry"></i>
                </span></p> */}
              {props.review.length > 20 ? <><p className="theme-col fs-12 f-700">Customer's Review:
                <p>{props.review.slice(0, 20)}
                  <span id={"dots" + props.id}>...</span>
                  <span id={"moreReview" + props.id} className="moreReviewsSection">{props.review.slice(20, props.review.length)}
                  </span>
                  <span className="reviewRmRl-label" onClick={() => showMoreLess(props.id)} id={"myBtn" + props.id}>Read more</span>
                </p>
              </p>
              </> : <><p className="theme-col fs-12 f-700">Customer's Review:
                <span>{props.review}
                </span>
              </p>
              </>
              }

            </div>
          </Row>
        </>
      )
  }

}
{/* <button onClick={() => showMoreLess(props.id)} id={"myBtn" + props.id}>Read more</button></>  */ }



export default ReviewCard;